module.exports = __webpack_public_path__ + "img/books2.9934715c.svg";